export default {
  screens: [
    {
      type: 'intro',
      title: 'ティアラの芸術',
      content:
        'ジュエラーにとっての究極の作品、メゾンの象徴、権力者のエンブレム、スタイリッシュなアクセサリー…。ディアデムは最も古典的なものから最も贅沢なものまで、あらゆる表現が可能です。',
      idYt: '2YX1UzJIlp0',
      videoCover: 'world/diademe/video.jpg',
      desktop: {
        cover: 'world/diademe/cover-1.jpg'
      },
      mobile: {
        cover: 'world/diademe/mobile-cover-1.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: 'auto',
          height: '65%',
          bottom: '-18%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'triangle',
      desktop: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      mobile: {
        topImg: 'world/diademe/triangleTop.jpg',
        btmImg: 'world/diademe/triangleBtm.jpg',
        cover: 'world/diademe/cover-2.jpg'
      },
      content:
        'ショーメは、1780年の創業以来、王侯貴族のために2000点を超えるティアラ、ヘッドバンド、エグレットを制作してきました。 <br/><br/> 美術展に展示されるティアラ約20点とニッケルシルバーモデル300点は、ショーメの創造性と卓越性を余すところなく表現しています。',
      isCover: true
    },
    {
      type: 'grid',
      videoBlock: {
        cover: 'world/diademe/video-diademe.jpg',
        idYt: 'IM2d5lCTqIA'
      },
      middleImg: 'world/diademe/gridMiddle.jpg',
      rightImg: 'world/diademe/gridRight.jpg',
      title: 'ティアラ「ヴェルティージュ」',
      content:
        '21世紀にふさわしいティアラを作る。これがショーメがセントラル・セント・マーチンズの学生たちに与えた課題でした。<br/><br/> スコット・アームストロングは、フランス式庭園からインスピレーションを得て、ティアラ「ヴェルティージュ」をデザインしました。カーブとストレートのラインを用いることで、ショーメの風景に新たな解釈をもたらしています。'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/jp/worlds/diademe.js